import { useEffect, useState } from "react";

// Wires top-level app navigation (which screen/tab is showing) to the
// browser's history stack. Without this, the SPA never touches history, so
// on a phone the hardware/gesture back button has nothing to pop and just
// exits the PWA instead of stepping back to the previous screen.
export function useHistoryNav<T>(initial: T): [T, (next: T) => void] {
  const [state, setState] = useState<T>(initial);

  useEffect(() => {
    history.replaceState({ tlbView: initial }, "");
    function onPopState(e: PopStateEvent) {
      const restored = e.state && typeof e.state === "object" && "tlbView" in e.state ? (e.state as any).tlbView : initial;
      setState(restored);
    }
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function push(next: T) {
    if (JSON.stringify(next) === JSON.stringify(state)) return;
    history.pushState({ tlbView: next }, "");
    setState(next);
  }

  return [state, push];
}
